export default __webpack_public_path__ + "media/images/favicon/logo-192-3236030ad687ce894c15d6dd3448b9a6.png";